import { Role } from 'enum/roles';

export const formatRole = (x?: Role[]): string => {
  return x?.map(r => r.toLowerCase().replace(/\b[a-z]/g, c => c.toUpperCase()).replace('-', ' ')).join(', ') || '';
};
